import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withStyles } from '~/themes/useStyles'
import style from './style'
import Button from '~/components/common/Button'
import GalleryDialog from '~/components/common/Gallery'
import { GALLERY_STEP } from '~/constants/product'

const GalleryForm = ({
  classes,
  className,
  setFieldValue,
  buttonUploadLabel,
  isProductMode,
  removeMedia,
  noUploadVideo,
  images,
  hideNoImage,
  thumbClassName,
  hasRemoveButton,
  disabled,
  buttonClassName,
}) => {
  const [gallerySelectFile, setGallerySelectFile] = useState(0)
  const [galleryStep, setGalleryStep] = useState(GALLERY_STEP.SELECT)
  const [openGallery, setOpenGallery] = useState(false)
  const setImages = useCallback(
    (v) => setFieldValue('image', v),
    [setFieldValue],
  )

  const handleSave = (fileSelected) => {
    setOpenGallery(false)
    setImages(fileSelected[0])
  }

  const handleOpenGallery = () => {
    if (disabled) return
    setOpenGallery(true)
    setGalleryStep(GALLERY_STEP.SELECT)
  }

  const handleOpenFileSelect = () => {
    if (disabled) return
    setGalleryStep(GALLERY_STEP.PREVIEW)
    setOpenGallery(true)
    setGallerySelectFile(0)
  }

  const handleRemoveImage = () => {
    setImages(null)
  }

  return (
    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
      {images[0]?.src || !hideNoImage ? (
        <div
          className={clsx(classes.thumbnail, thumbClassName)}
          style={{
            backgroundImage: `url("${images[0]?.src}"), url('/icons/default_thumbnail.svg')`,
          }}
          role="presentation"
          onClick={images[0]?.src ? handleOpenFileSelect : handleOpenGallery}
        />
      ) : (
        ''
      )}
      {images[0]?.src && hasRemoveButton ? (
        <div className={clsx(className)}>
          <Button
            className={clsx(classes.selectFileButton, buttonClassName)}
            fullWidth={false}
            color="secondary"
            label="Remove Image"
            onClick={handleRemoveImage}
            disabled={disabled}
          />
        </div>
      ) : (
        <div className={clsx(className)}>
          <Button
            className={clsx(classes.selectFileButton, buttonClassName)}
            fullWidth={false}
            color="secondary"
            label={buttonUploadLabel}
            onClick={handleOpenGallery}
            disabled={disabled}
          />
        </div>
      )}
      <GalleryDialog
        images={images}
        openGallery={openGallery}
        setOpenGallery={setOpenGallery}
        gallerySelectFile={gallerySelectFile}
        setGallerySelectFile={setGallerySelectFile}
        galleryStep={galleryStep}
        setGalleryStep={setGalleryStep}
        handleSave={handleSave}
        multiple={false}
        isProductMode={isProductMode}
        removeMedia={removeMedia}
        noUploadVideo={noUploadVideo}
        enabledEditMetadataIds={['alternative_text', 'title']}
      />
    </div>
  )
}

GalleryForm.defaultProps = {
  className: '',
  thumbClassName: '',
  buttonClassName: '',
  setFieldValue: () => {},
  buttonUploadLabel: 'Select Image',
  isProductMode: false,
  removeMedia: false,
  noUploadVideo: false,
  images: [],
  hideNoImage: false,
  hasRemoveButton: false,
  disabled: false,
}

GalleryForm.propTypes = {
  classes: PropTypes.shape().isRequired,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  thumbClassName: PropTypes.string,
  setFieldValue: PropTypes.func,
  buttonUploadLabel: PropTypes.string,
  isProductMode: PropTypes.bool,
  removeMedia: PropTypes.bool,
  noUploadVideo: PropTypes.bool,
  images: PropTypes.oneOfType([PropTypes.array, PropTypes.shape]),
  hideNoImage: PropTypes.bool,
  hasRemoveButton: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default React.memo(withStyles(style)(GalleryForm))
